module.exports = __webpack_public_path__ + "static/media/icon_menu_black.52361801.svg";